import React from 'react';
import { IconRender, InheritProps } from './../IconRender';

export function SquareIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
          <rect
            x='2'
            y='2'
            width='66'
            height='66'
            rx='8'
            fill='#343434'
            stroke={color}
            strokeWidth='4'
          />
          <path
            d='M21.3258 56.3501L21.3257 19.2646L56.1399 19.2645'
            stroke='white'
            strokeWidth='4'
          />
        </>
      )}
    />
  );
}
